import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./Nwreu.module.css";
import { FaArrowLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import Loader from "../Loader/Loader";

const ITEMS_PER_PAGE = 20;

const AgendaItems = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://nwreu-backend-seven.vercel.app/pnm-agenda"
        );

        // KEEP YOUR SORTING (latest first)
        const sortedData = response.data.sort((a, b) => {
          const aParts = a.sNo.split("/").map(Number);
          const bParts = b.sNo.split("/").map(Number);
          return bParts[1] - aParts[1] || bParts[0] - aParts[0];
        });

        setData(sortedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentData = data.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const getPageNumbers = () => {
    const pages = [];
    const delta = 2;

    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);

    pages.push(1);

    if (left > 2) pages.push("...");

    for (let i = left; i <= right; i++) {
      pages.push(i);
    }

    if (right < totalPages - 1) pages.push("...");

    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  return (
    <div className={styles.TableContainer}>
      <Link to="/PNM-NWREU">
        <span className={styles.header}>
          <FaArrowLeft />
          <h2>GM-PNM-NWREU (Click Here)</h2>
        </span>
      </Link>

      {loading ? (
        <Loader />
      ) : (
        <>
          <table className={styles.membersTable}>
            <thead>
              <tr>
                <th>S.No</th>
                <th>PNM Items</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, index) => (
                <tr key={startIndex + index}>
                  <td>{item.sNo}</td>
                  <td>
                    <a
                      href={item.pnmItemLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${styles.noDecoration} ${styles.linkText}`}
                    >
                      {item.pnmItem}
                    </a>
                  </td>
                  <td>{item.remarks}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
          <div className={styles.pagination}>
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>

            {getPageNumbers().map((page, index) =>
              page === "..." ? (
                <span key={index} className={styles.ellipsis}>
                  …
                </span>
              ) : (
                <button
                  key={index}
                  className={
                    currentPage === page ? styles.activePage : styles.pageBtn
                  }
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              )
            )}

            <button
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>

            <span className={styles.jump}>
              Go to:
              <input
                type="number"
                min="1"
                max={totalPages}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const val = Number(e.target.value);
                    if (val >= 1 && val <= totalPages) {
                      setCurrentPage(val);
                    }
                  }
                }}
              />
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default AgendaItems;
